import {
  DeliverableGroupKey,
  FeatureKey,
} from "data/models/feature-lane";

import {QuestionKey, SurveyKey} from "data/models/survey/keys";

export type FeatureKeyForNavigation = FeatureKey | "first" | "last";
export type SurveyKeyForNavigation = SurveyKey | "first" | "last";
export type QuestionKeyForNavigation = QuestionKey | "first" | "last";

export type SurveyQuestionPath = {
  deliverableGroupId: DeliverableGroupKey,
  featureIdForNavigation: FeatureKeyForNavigation,
  surveyIdForNavigation: SurveyKeyForNavigation,
  questionIdForNavigation: QuestionKeyForNavigation,
}

export function surveyQuestionPath(
    deliverableGroupId: DeliverableGroupKey,
    featureIdForNavigation: FeatureKeyForNavigation,
    surveyIdForNavigation: SurveyKeyForNavigation,
    questionIdForNavigation: QuestionKeyForNavigation,
) {
  return `/survey/${deliverableGroupId}/${featureIdForNavigation}/${surveyIdForNavigation}/${questionIdForNavigation}`;
}
